import { BrowserRouter, Routes, Route } from "react-router";
import { lazy, Suspense } from "react";
import { Layout } from "./components/Layout";

const Home = lazy(() => import("./pages/Home"));
const StyleLanding = lazy(() => import("./pages/StyleLanding"));
const GenerateArt = lazy(() => import("./pages/GenerateArt"));
const ShopHome = lazy(() => import("./pages/ShopHome"));
const ShopPosterDetail = lazy(() => import("./pages/ShopPosterDetail"));
const ShopPersonalize = lazy(() => import("./pages/ShopPersonalize"));
const PaymentSuccess = lazy(() => import("./pages/PaymentSuccess"));
const Wall = lazy(() => import("./pages/Wall"));
const MyCreations = lazy(() => import("./pages/MyCreations"));
const About = lazy(() => import("./pages/About"));
const Login = lazy(() => import("./pages/Login"));
const SignUp = lazy(() => import("./pages/SignUp"));
const CreatePassword = lazy(() => import("./pages/CreatePassword"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const Article = lazy(() => import("./pages/Article"));
const Articles = lazy(() => import("./pages/Articles"));
const Legal = lazy(() => import("./pages/Legal"));
const UnsubscribeMemories = lazy(() => import("./pages/UnsubscribeMemories"));
const NotFound = lazy(() => import("./pages/NotFound"));

function PageFallback() {
  return <div className="flex flex-1 items-center justify-center" />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="style/:styleId" element={<StyleLanding />} />
            <Route path="about" element={<About />} />
            <Route path="shop" element={<ShopHome />} />
            <Route path="shop/posters/:slug" element={<ShopPosterDetail />} />
            <Route path="shop/personalize/:sessionId" element={<ShopPersonalize />} />
            <Route path="generate-art/:id" element={<GenerateArt />} />
            <Route path="wall" element={<Wall />} />
            <Route path="my-creations" element={<MyCreations />} />
            <Route path="payments/success" element={<PaymentSuccess />} />
            <Route path="login" element={<Login />} />
            <Route path="sign-up" element={<SignUp />} />
            <Route path="create-password" element={<CreatePassword />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="reset-password/complete" element={<ResetPassword />} />
            <Route path="articles" element={<Articles />} />
            <Route path="articles/:slug" element={<Article />} />
            <Route path="terms" element={<Legal />} />
            <Route path="privacy" element={<Legal />} />
            <Route path="disclaimer" element={<Legal />} />
            <Route path="unsubscribe/memories" element={<UnsubscribeMemories />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
